import React from 'react'
import { Box, Grid, Typography } from '@mui/material'
import { map } from 'lodash'
import PropTypes from 'prop-types'

function ImageGallery({ images, title }) {
  return (
    <>
      {title && (
        <Typography align="center" variant="h3">
          {title}
        </Typography>
      )}
      <Box sx={{ mt: 2 }}>
        <Grid container spacing={2}>
          {map(images, (image, key) => (
            <Grid key={key} item xs={4}>
              <img
                src={image.imageUrl}
                alt=""
                style={{
                  width: '100%',
                  height: 'auto',
                }}
              />
              <Typography variant="body2" sx={{ mt: 1 }}>
                <strong>{image.name}</strong>
              </Typography>
            </Grid>
          ))}
        </Grid>
      </Box>
    </>
  )
}

ImageGallery.propTypes = {
  images: PropTypes.array,
  title: PropTypes.string,
}

ImageGallery.defaultProps = {
  images: [],
  title: null,
}

export default ImageGallery
